import { createWebHistory, createRouter } from 'vue-router'

// TODO vue typings
// @ts-ignore
import Login from '@/pages/login.vue'
// @ts-ignore
import Forget from '@/pages/forget.vue'
// @ts-ignore
import Reset from '@/pages/reset.vue'
// @ts-ignore
import OAuth from '@/pages/oauth.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { title: '登录/注册' }
  },
  {
    path: '/forget',
    name: 'forget',
    component: Forget,
    meta: { title: '找回密码' }
  },
  {
    path: '/reset',
    name: 'reset',
    component: Reset,
    meta: { title: '重置密码' }
  },
  {
    path: '/oauth',
    name: 'oauth',
    component: OAuth,
    meta: { title: '绑定' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory('/auth'),
  routes,
})

export default router
